/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from "react";
import { withRouter } from "react-router-dom";
import Page from "components/common_components/Page/Page";
import Form from "./Form";
import { useDispatch } from "react-redux";
import { notifySuccess, notifyError } from "redux/actions/Notifications";
import LoadingPage from "components/common_components/LoadingPage";
import SettingsContext from "../SettingsContext";
import Button from "components/common_components/Button";

function InvoicingIssuer() {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [invoicingIssuer, setInvoicingIssuer] = useState(undefined);
    const [mode, setMode] = useState("view");

    const { InvoicingIssuers } = useContext(SettingsContext);

    const getInvoicingIssuer = async () => {
        try {
            setIsLoading(true);
            const response = await InvoicingIssuers.getAsync();
            setInvoicingIssuer(response || { name: "", address: "", phoneNumber: null, email: null, fax: null });
        } catch (error) {
            dispatch(notifyError(error));
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getInvoicingIssuer();

        return () => {
            setInvoicingIssuer(undefined);
            setMode("view");
        };
    }, []);

    function onCancelHandler() {
        setMode("view");
    }

    function onSuccess(_, setSubmitting) {
        setSubmitting(false);
        onCancelHandler();
        dispatch(notifySuccess(`Invoice Issuer saved successfully!`));
    }

    function onError(error, setSubmitting, setErrors) {
        if (error && error.errors) {
            setErrors(error.errors);
            dispatch(notifyError(error.message));
        } else {
            onCancelHandler();
            dispatch(notifyError(error));
        }
        setSubmitting(false);
    }

    async function onSubmitHandler(values, { setSubmitting, setErrors }) {
        const { name, address, phoneNumber, email, fax } = values;

        try {
            setSubmitting(true);
            const response = await InvoicingIssuers.addAsync({ name, address, phoneNumber, email, fax });
            setInvoicingIssuer(response);
            onSuccess(response, setSubmitting);
        } catch (error) {
            onError(error, setSubmitting, setErrors);
        }
    }

    function onAddHandler() {
        setMode("add");
    }

    return (
        <Page>
            {isLoading ? (
                <LoadingPage />
            ) : (
                <>
                    <Form
                        data={invoicingIssuer}
                        mode={mode}
                        onSubmit={onSubmitHandler}
                        onCancel={onCancelHandler}
                        title="Documents Issuer Information"
                    />
                    {mode === "view" && (
                        <div className="button-group">
                            <Button onClick={onAddHandler} primary>
                                Change
                            </Button>
                        </div>
                    )}
                </>
            )}
        </Page>
    );
}

export default withRouter(InvoicingIssuer);
